export type TableRows = string[][]

export const TABLE_MAX_COLUMNS = 6

export function createTable(headers: string[], bodyRows = 2): TableRows {
  return [headers, ...Array.from({ length: bodyRows }, () => headers.map(() => ''))]
}

export function columnCount(rows: TableRows): number {
  return rows[0]?.length ?? 0
}

export function setCell(rows: TableRows, r: number, c: number, value: string): TableRows {
  return rows.map((row, ri) => (ri === r ? row.map((cell, ci) => (ci === c ? value : cell)) : row))
}

export function addRow(rows: TableRows, after = rows.length - 1): TableRows {
  const next = rows.map((row) => [...row])
  next.splice(Math.max(after, 0) + 1, 0, Array.from({ length: columnCount(rows) }, () => ''))
  return next
}

export function addColumn(rows: TableRows, header: string, after = columnCount(rows) - 1): TableRows {
  if (columnCount(rows) >= TABLE_MAX_COLUMNS) return rows
  const at = Math.max(after, -1) + 1
  return rows.map((row, ri) => {
    const next = [...row]
    next.splice(at, 0, ri === 0 ? header : '')
    return next
  })
}

export function removeRow(rows: TableRows, r: number): TableRows {
  if (r <= 0 || rows.length <= 2) return rows
  return rows.filter((_, ri) => ri !== r)
}

export function removeColumn(rows: TableRows, c: number): TableRows {
  if (columnCount(rows) <= 1) return rows
  return rows.map((row) => row.filter((_, ci) => ci !== c))
}

export function rowHasContent(rows: TableRows, r: number): boolean {
  return (rows[r] ?? []).some((cell) => cell.trim() !== '')
}

export function columnHasContent(rows: TableRows, c: number): boolean {
  return rows.slice(1).some((row) => (row[c] ?? '').trim() !== '')
}
